import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import InputMonetario from "components/input/InputMonetario";
import Produto from "model/administracao/cadastro/produto/Produto";
import Deposito from "model/suprimentos/Deposito";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import ItemTransferencia from "model/suprimentos/ItemTransferencia";
import Transacao from "model/suprimentos/Transacao";
import TransferenciaEstoque from "model/suprimentos/TransferenciaEstoque";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Column, ColumnBodyOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext"
import { useEffect, useRef, useState } from "react";
import TransfereniciaEstoqueService from "service/suprimentos/TransferenciaEstoqueService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";


type Props = {

}

const transferenciaEstoqueService = new TransfereniciaEstoqueService();

export default function TransferenciaCadastro(props: Props) {

    const { msgAlerta, msgErro, msgSucesso } = useToastContext();

    const [transferenciaEstoque, setTransferenciaEstoque] = useState<TransferenciaEstoque>(new TransferenciaEstoque());

    const [transferido, setTransferido] = useState<boolean>(false);

    const [transacoesEntrada, setTransacoesEntrada] = useState<Transacao[]>([]);
    const [transacoesSaida, setTransacoesSaida] = useState<Transacao[]>([]);
    const [depositos, setDepositos] = useState<Deposito[]>([]);

    const [produtosDisponives, setProdutosDisponives] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdutosFiltrados] = useState<Produto[]>([]);
    const [lotesDisponiveis, setLotesDisponiveis] = useState<EstoqueLote[]>([]);

    const depositoOrigemRef = useRef<any>(null);



    useEffect(() => {
        transferenciaEstoqueService.getDepositos().then((data) => {
            setDepositos(data);
        }).catch((error) => {
            console.log(error);
        });

        transferenciaEstoqueService.getTransacoesEntrada().then((data) => {
            setTransacoesEntrada(data);
        }).catch((error) => {
            console.log(error);
        });

        transferenciaEstoqueService.getTransacoesSaida().then((data) => {
            setTransacoesSaida(data);
        }).catch((error) => {
            console.log(error);
        });

        transferenciaEstoqueService.getTransacaoPadraoEntrada().then((data) => {
            let transferenciaLocal = { ...transferenciaEstoque }
            transferenciaLocal = { ...transferenciaLocal, transacaoEntrada: data };
            transferenciaEstoqueService.getTransacaoPadraoSaida().then((data) => {
                transferenciaLocal = { ...transferenciaLocal, transacaoSaida: data };
                setTransferenciaEstoque(transferenciaLocal);
            }).catch((error) => {
                console.log(error);
            });
        }).catch((error) => {
            console.log(error);
        });




    }, [])

    useEffect(() => {
        transferenciaEstoqueService.getProdutosDisponiveis(transferenciaEstoque.depositoOrigem).then((data) => {
            setProdutosDisponives(data);
        }).catch((error) => {
            console.log(error);
        });
    }, [transferenciaEstoque.depositoOrigem])

    const header = (
        <div style={{ textAlign: 'center', position: 'relative' }}>
            <span>Itens</span>
            <Button disabled={transferido} style={{ position: 'absolute', right: 0, bottom: '-8px' }}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                tooltip="Adicionar"
                tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => novoItem()}
            ></Button>
        </div>
    )

    function novoItem() {
        transferenciaEstoque.itens.push(new ItemTransferencia());
        setTransferenciaEstoque({ ...transferenciaEstoque });
    }

    function getLotesDisponiveis(deposito: Deposito, produto: Produto) {
        transferenciaEstoqueService.getLotesDisponiveis(deposito, produto).then((data) => {
            setLotesDisponiveis(data);
        }).catch((error) => {
            console.log(error);
        });
    }

    function transferir() {
        if (!podeTransferir()) {
            return;
        }
        transferenciaEstoqueService.transferir(transferenciaEstoque).then(() => {
            msgSucesso("Transferência de estoque", "Transferência realizada com sucesso");
            setTransferido(true);
        }).catch((error) => {
            console.log(error)
            msgAlerta("Transferência de estoque", error.data.message);
        });
    }

    function podeTransferir() {
        if (transferenciaEstoque.transacaoEntrada === null || transferenciaEstoque.transacaoEntrada.codigo === null) {
            msgAlerta("Transação de entrada", "Informe a transação de entrada");
            return false;
        }
        if (transferenciaEstoque.transacaoSaida === null || transferenciaEstoque.transacaoSaida.codigo === null) {
            msgAlerta("Transação de Saida", "Informe a transação de saída");
            return false;
        }
        if (transferenciaEstoque.depositoOrigem === null || transferenciaEstoque.depositoOrigem.codigo === null) {
            msgAlerta("Depósito de Origem", "Informe o depósito de origem");
            return false;
        }
        if (transferenciaEstoque.depositoDestino === null || transferenciaEstoque.depositoDestino.codigo === null) {
            msgAlerta("Depósito de Destino", "Informe o depósito de destino");
            return false;
        }
        if (transferenciaEstoque.depositoOrigem.codigo == transferenciaEstoque.depositoDestino.codigo) {
            msgAlerta("Depósitos", "Depósito de origem e destino não podem ser iguais");
            return false;
        }


        if (transferenciaEstoque.itens.length == 0) {
            msgAlerta("Itens", "Informe os itens");
            return false;
        }

        for (let i = 0; i < transferenciaEstoque.itens.length; i++) {
            const item = transferenciaEstoque.itens[i];
            if (item.produto == null || !item.produto.codigo) {
                msgAlerta("Produto", "Informe o produto no item " + (i + 1));
                return false;
            }
            if (item.lote == null || !item.lote.lote) {
                msgAlerta("Lote", "Informe o lote no item " + (i + 1));
                return false;
            }
            if (item.quantidade == 0) {
                msgAlerta("Quantidade", "Informe a quantidade no item " + (i + 1));
                return false;
            }
        }

        return true;
    }

    return (

        <div className="container">

            <div className="row">
                <label className="col col-sm-12">Transação de entrada</label>
                <div className="col-sm-12">
                    <Dropdown disabled={transferido} value={transferenciaEstoque.transacaoEntrada} options={transacoesEntrada} optionLabel="descricao" onChange={(e) => setTransferenciaEstoque({ ...transferenciaEstoque, transacaoEntrada: e.value })} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Transação de saída</label>
                <div className="col-sm-12">
                    <Dropdown disabled={transferido} value={transferenciaEstoque.transacaoSaida} options={transacoesSaida} optionLabel="descricao" onChange={(e) => setTransferenciaEstoque({ ...transferenciaEstoque, transacaoSaida: e.value })} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Depósito de Origem</label>
                <div className="col-sm-12">
                    <Dropdown
                        disabled={transferido}
                        ref={depositoOrigemRef}
                        value={transferenciaEstoque.depositoOrigem}
                        options={depositos} optionLabel="nome"
                        onChange={(e) => setTransferenciaEstoque({ ...transferenciaEstoque, depositoOrigem: e.value })}
                        style={{ width: '30%' }}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col col-sm-12">Depósito de Destino</label>
                <div className="col-sm-12">
                    <Dropdown disabled={transferido} value={transferenciaEstoque.depositoDestino} options={depositos} optionLabel="nome" onChange={(e) => setTransferenciaEstoque({ ...transferenciaEstoque, depositoDestino: e.value })} style={{ width: '30%' }} />
                </div>
            </div>

            <div className="row" style={{ marginTop: 20 }}>
                <div className="col col-sm-12">
                    <DataTable
                        value={transferenciaEstoque.itens}
                        header={header}
                        scrollHeight="500px"
                        scrollable={true}
                        emptyMessage="Nenhum registro encontrado"
                    >
                        <Column field="produto.nome" body={(rowData) =>
                            <AutoComplete
                                placeholder="Selecione o produto" disabled={transferido} value={rowData.produto}
                                suggestions={produtosFiltrados} field="nome"
                                itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                                completeMethod={(e) => {
                                    let filtered = produtoCompleteMethod(produtosDisponives, e.query);
                                    setProdutosFiltrados(filtered);
                                }}
                                onChange={(e) => {
                                    if (typeof e.target.value == "string") {
                                        let prod = new Produto();
                                        prod.nome = e.target.value;
                                        rowData.produto = prod;
                                    } else {
                                        rowData.produto = e.target.value;
                                        getLotesDisponiveis(transferenciaEstoque.depositoOrigem, e.target.value);

                                    }
                                    setTransferenciaEstoque({ ...transferenciaEstoque })
                                }}
                                onFocus={(e) => {
                                    if (transferenciaEstoque.depositoOrigem == null || transferenciaEstoque.depositoOrigem.codigo == null) {
                                        if (depositoOrigemRef.current) {
                                            depositoOrigemRef.current.focus();
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                inputStyle={{ width: '100%' }}
                                style={{ width: '100%' }}
                            />

                        } header="Produto"></Column>
                        <Column field="lote" header="Lote" body={(rowData, options: ColumnBodyOptions) =>
                            <Dropdown disabled={transferido} value={rowData.lote} options={lotesDisponiveis} optionLabel="lote"
                                onChange={(e) => {
                                    rowData.lote = e.value;

                                    transferenciaEstoqueService.getValorUnitario(e.value).then((data) => {
                                        rowData.valorUnitario = data;
                                        setTransferenciaEstoque({ ...transferenciaEstoque })
                                    }).catch((error) => {
                                        console.log(error);
                                    });
                                    
                                }}
                                style={{ width: '100%' }}
                            />
                        }></Column>
                        <Column field="quantidade" header="Quantidade" body={(rowData) =>
                            <InputNumber disabled={transferido} value={rowData.quantidade} useGrouping={false}
                                onFocus={(e) => e.target.select()}
                                locale="pt-BR"
                                minFractionDigits={1} maxFractionDigits={5} maxLength={10}
                                onChange={(e) => {
                                    rowData.quantidade = e.value;
                                    setTransferenciaEstoque({ ...transferenciaEstoque })
                                }}
                                style={{ width: '100%' }}
                            />
                        }></Column>
                        <Column field="valorUnitario" header="Valor Unitário" body={(rowData) =>
                            <InputMonetario disabled={transferido} value={rowData.valorUnitario}
                                onChange={(e) => {
                                    rowData.valorUnitario = e;
                                    setTransferenciaEstoque({ ...transferenciaEstoque })
                                }}
                            />
                        }></Column>
                    </DataTable>
                </div>
            </div>

            <div className="row" style={{ marginTop: 20 }}>
                <div className="col col-sm-12">

                    <Button disabled={transferido} label="Transferir" onClick={() => {
                        transferir();
                    }}></Button>
                    {transferido && <Button label="Nova Transferência" style={{ marginLeft: 10 }} onClick={() => {
                        setTransferenciaEstoque(new TransferenciaEstoque());
                        setTransferido(false);
                    }} ></Button>}
                </div>
            </div>



        </div>


    )

}